var _style, _polygon, _path, _path2, _path3, _path4, _path5, _path6, _line, _path7, _path8, _g, _circle, _path9, _path10, _path11, _path12, _path13, _line2, _path14, _circle2, _path15, _path16, _path17, _path18, _path19, _path20, _circle3, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _circle4, _path28, _path29, _path30, _defs, _path31, _polyline, _path32, _line3, _defs2, _defs3, _defs4, _path33, _path34, _g2, _g3, _defs5, _defs6, _polygon2, _defs7, _path35, _polyline2, _path36, _polyline3, _line4, _defs8, _defs9, _defs10, _path37, _g4, _g5, _defs11, _defs12, _g6, _g7;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurveyFlipLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48.9 38",
    style: {
      enableBackground: "new 0 0 48.9 38"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#FFB600;}\n\t.st2{display:inline;fill:none;stroke:#000000;stroke-width:4.9164;stroke-miterlimit:10;}\n\t.st3{display:inline;}\n\t.st4{display:inline;fill:none;stroke:#6000D6;stroke-width:3;stroke-miterlimit:10;}\n\t.st5{display:inline;fill:#6000D6;}\n\t.st6{clip-path:url(#SVGID_00000179620362128672136180000000618693615094114195_);}\n\t.st7{fill:none;stroke:#6000D6;stroke-width:12;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#FFB600;stroke-width:10;stroke-miterlimit:10;}\n\t.st9{display:inline;fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\n\t\n\t\t.st10{clip-path:url(#SVGID_00000050650496456714146760000002648268675262538422_);fill:none;stroke:#6000D6;stroke-width:17;stroke-miterlimit:10;}\n\t\n\t\t.st11{clip-path:url(#SVGID_00000048459556594031841360000006382884638909830078_);fill:none;stroke:#FFB600;stroke-width:17;stroke-miterlimit:10;}\n\t\n\t\t.st12{clip-path:url(#SVGID_00000015354167159673125100000011174067936224564403_);fill:none;stroke:#FFB600;stroke-width:17;stroke-miterlimit:10;}\n\t.st13{display:inline;fill:none;stroke:#6A10E8;stroke-width:1.2616;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st14{fill:#FFFFFF;}\n\t\n\t\t.st15{clip-path:url(#SVGID_00000173153806509103160010000012142201488234583226_);fill:none;stroke:#6000D6;stroke-width:12;stroke-miterlimit:10;}\n\t.st16{clip-path:url(#SVGID_00000026854233636957767590000010928299186389660351_);fill:#FFB600;}\n\t.st17{display:inline;fill:#FF1D25;}\n\t.st18{clip-path:url(#SVGID_00000134229191710880055220000009184642552822107572_);}\n\t.st19{fill:none;stroke:#FF0000;stroke-width:10;stroke-miterlimit:10;}\n\t\n\t\t.st20{clip-path:url(#SVGID_00000017495565689096957770000009210442626506948496_);fill:none;stroke:#6000D6;stroke-width:17;stroke-miterlimit:10;}\n\t\n\t\t.st21{clip-path:url(#SVGID_00000106835811479140586590000015095244779567857572_);fill:none;stroke:#FF0000;stroke-width:17;stroke-miterlimit:10;}\n\t\n\t\t.st22{clip-path:url(#SVGID_00000075883391346984817750000011685499868216685207_);fill:none;stroke:#FF0000;stroke-width:17;stroke-miterlimit:10;}\n\t\n\t\t.st23{clip-path:url(#SVGID_00000081645485666420686820000017034876457828951230_);fill:none;stroke:#6000D6;stroke-width:12;stroke-miterlimit:10;}\n\t.st24{clip-path:url(#SVGID_00000053525823574960394070000009608009170151990966_);fill:#FF1D25;}\n\t.st25{fill:#E23B53;}\n\t.st26{fill:#354154;}\n\t.st27{fill:#2D6B7A;}\n\t.st28{fill:#B2E1E8;}\n\t.st29{opacity:0.5;fill:#2D6B7A;enable-background:new    ;}\n\t.st30{fill:#0261BF;}\n\t.st31{fill:#04D3B7;}\n\t.st32{fill:#FFCC00;}\n\t.st33{fill:#FF7979;}\n\t.st34{fill:#FF6666;}\n\t.st35{fill:#C9AC80;}\n\t.st36{fill:#18332F;}\n\t.st37{fill:#FABE8A;}\n\t.st38{fill:#390772;}\n\t.st39{opacity:0.14;fill:#FABE8A;enable-background:new    ;}\n\t.st40{fill:#F6EE33;}\n\t.st41{fill:#40404A;}\n\t.st42{fill:#DB261D;}\n\t.st43{fill:#11418B;}\n\t.st44{fill:none;stroke:#6A10E8;stroke-width:1.2616;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st45{fill:#333333;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000125577426316168936510000003500088216864527032_",
    className: "st0"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "83.8,557.1 110.1,553 110.1,567.8 95.9,570.2 95.9,584.1 83.8,586 77.3,585 77.8,556.1  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-72.5-50.4c16-16-24.8-22.8-29.2-5.3c-2.4,9.6,9.5,12.1,20.2,15.3c27.9,8.4,1.8,25.5-16,16 c-4.4-2.4-5-6.3-3.1-9.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-59.8-54.4c0,0,0.1,19,0.2,26c0.2,6,5.3,7.9,9.2,5.9c11-5.9,10.1-31.9,10.1-31.9s0,12.1,0,15.8 c0,6.2,0,12.4,0,18.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-30.4-20.1v-31.8c0,0,11.2-1.9,15.9,1.5c7,5,2,16-3,11"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-4.4-54.3c0,0,7.2,32,11.9,32c3,0,15-25.5,11.4-29.4c-2.4-2.6-3.6,1.4-1.4,4.4c3,4,8,11,23,9 c12.1-1.6,14.4-10.3,9-13c-6-3-13.6-1.1-18,4.5c-6.3,8.1-6.9,26.6,10,24.5c8-1,13-6,19-14"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.2-54.2c0,0,0,15.2,0,20c0,7.8,3.4,10.8,7.4,9.8C84.9-28.5,84-54.2,84-54.2S84-25.8,84,2 c0,1-18.3,4.3-17.4-7.3c1-13,22-17,27-15"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M133.4-59.9c0,0,0.1-6.7-5.2-6.7c-2.3,0-21.4,0-21.4,0l0.6,46.9"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 127.4,
    y1: -41.8,
    x2: 108.9,
    y2: -41.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M145.4-69.9c0.2,19.5,0.2,34.5,0,47.5c19.2,2,20.1-27.5,20.1-32.1c0,0-0.9,20.1,0,32.1 c16.1,3,17.8-31.8,17.8-31.8V4.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M183.4-40.9c0-15.5,24.1-15.5,24.6,2.5c0.5,20-23.8,15.8-24.5,10"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M253.6-26.4l3.2-3.7c3.1,3.2,7.3,5.3,11.8,5.3c5.6,0,8.9-2.8,8.9-6.9c0-4.4-3.1-5.8-7.1-7.5l-6.1-2.7 c-4-1.7-8.6-4.7-8.6-11c0-6.5,5.7-11.3,13.4-11.3c5.1,0,9.6,2.2,12.6,5.3l-2.9,3.5c-2.6-2.5-5.7-4-9.7-4c-4.8,0-8,2.4-8,6.2 c0,4.1,3.7,5.7,7.1,7.1l6.1,2.6c4.9,2.1,8.8,5.1,8.8,11.4c0,6.7-5.6,12.1-14.5,12.1C262.6-20.1,257.4-22.5,253.6-26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.5-32.5v-20h5.4v19.3c0,5.9,1.8,8.4,6,8.4c3.2,0,5.5-1.6,8.5-5.3v-22.4h5.4v31.6h-4.4l-0.5-4.9h-0.2 c-2.9,3.5-6.1,5.7-10.4,5.7C293.5-20.1,290.5-24.4,290.5-32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.3-52.5h4.4l0.5,5.8h0.2c2.2-4,5.4-6.5,9-6.5c1.4,0,2.4,0.2,3.4,0.7l-1,4.7c-1.1-0.3-1.8-0.5-3.1-0.5 c-2.7,0-5.9,1.9-8,7.3v20.3h-5.4V-52.5L326.3-52.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.3-52.5h5.5l6,18c0.9,3.1,2,6.3,2.9,9.3h0.3c0.9-3,2-6.2,2.9-9.3l6-18h5.2L362-20.9h-6.2L344.3-52.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.9-36.7c0-10.3,6.9-16.6,14.2-16.6c8.1,0,12.6,5.8,12.6,14.8c0,1.1-0.1,2.3-0.2,3h-21.3c0.4,6.7,4.5,11,10.5,11 c3,0,5.5-1,7.9-2.5l1.9,3.5c-2.8,1.8-6.1,3.3-10.4,3.3C383.6-20.1,376.9-26.3,376.9-36.7z M399-39.2c0-6.3-2.9-9.8-7.8-9.8 c-4.4,0-8.4,3.6-9.1,9.8H399z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.3-7.9l1-4.3c0.6,0.2,1.6,0.5,2.4,0.5c3.6,0,5.8-2.9,7.1-6.8l0.7-2.3l-12.7-31.7h5.5l6.5,17.5c1,2.7,2,6,3.1,8.9h0.3 c0.9-2.9,1.8-6.1,2.7-8.9l5.6-17.5h5.2l-11.9,34.2c-2.2,6.3-5.5,11-11.8,11C410.5-7.3,409.3-7.5,408.3-7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.3-63.5h24.6v4.6h-19.2v14.4H464v4.6h-16.3v19.1h-5.4L442.3-63.5L442.3-63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.9-27.2v-40h5.4v40.3c0,1.6,0.7,2.3,1.5,2.3c0.3,0,0.6,0,1.2-0.1l0.7,4.1c-0.8,0.3-1.7,0.5-3.1,0.5 C475.6-20.1,473.9-22.7,473.9-27.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.5-62.4c0-2.1,1.6-3.4,3.7-3.4s3.7,1.3,3.7,3.5c0,2-1.6,3.5-3.7,3.5S489.5-60.4,489.5-62.4z M490.5-52.5h5.4v31.6 h-5.4V-52.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.5-52.5h4.4l0.5,3.7h0.2c2.9-2.4,6.4-4.4,10.1-4.4c8.2,0,12.5,6.3,12.5,16.1c0,10.8-6.5,17.1-13.7,17.1 c-2.9,0-5.9-1.3-8.8-3.7l0.1,5.5v10.7h-5.4L506.5-52.5L506.5-52.5z M528.6-37.1c0-7-2.4-11.6-8.3-11.6c-2.7,0-5.4,1.5-8.5,4.3 v16.6c2.9,2.4,5.6,3.3,7.7,3.3C524.8-24.6,528.6-29.3,528.6-37.1z"
  })))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 128.2204 376.5373)",
    className: "st3",
    style: {
      fontFamily: "'MicrosoftNewTaiLue-Bold'",
      fontSize: 52
    }
  }, "SurveyFlip"), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 165,
    cy: -62.9,
    r: 3.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-0.8,71.6c0.6-0.5,1.9-1.8,1.9-2.5c-0.4-5.2-11.9-6-13.5,0.6c-1,4,2.3,5.5,6.9,5.8c9.7,0.6,7.7,7.2,2.9,8.1 c-4,0.7-12,0.1-10-4.8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M7,70.2c0,0,0.1,7.1,0.1,9c0.2,6.3,8,3.1,8-0.2c0.1-2.5,0-8.8,0-8.8s0,5.1,0,6.6c0,2.6,0,5.1,0,7.7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M34,70.2c0,0,3,13.3,5,13.3c1.2,0,6.2-10.6,4.8-12.2c-1-1.1-1.5,0.6-0.6,1.8c1.2,1.7,5.2,4.6,11.4,3.8 c5-0.7,6-4.3,3.8-5.4c-2.5-1.2-5.7-0.5-7.5,1.9c-2.7,3.3-2.9,11,4.1,10.2c3.3-0.4,8-2.9,10.5-6.2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M65.5,70.3c0,0,0,5.1,0,7.1c0,3.2,1.5,6.2,5.3,4.2C75,79.3,75,70.3,75,70.3s0,5.5,0,17.1 c0,7.4-8.6,7.6-8.6,3.6c0-6.3,8.6-5.1,12.7-4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M92.4,66C87.8,64.2,82,65.2,82,65.2l0.2,19.5"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 90.4,
    y1: 74.1,
    x2: 82.5,
    y2: 74.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M95.6,63.8c0.1,7.2-0.1,11.4-0.1,15.6c0,8.1,7.9,1.9,7.9-3.9c0-3,0-5.3,0-5.3c0,6.1,0,6.1,0,11.1 c0,4.8,7.9,0.8,7.9-6.3c0-3.7,0-4.6,0-4.6v24.5c0,0-0.6-17.1,1.9-20.7c3.6-5.3,12.5-2.8,10.7,5.3c-1.2,5.2-9.1,4.9-7.9,1.2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 103.4,
    cy: 66.7,
    r: 2.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M29.1,75.5c-0.2-6.3-8-3.1-8,0.2c0,2.5,0,8.8,0,8.8s0-5.1,0-6.6c0-2.6,0-5.1,0-7.7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M270.2,71.6c0.6-0.5,1.9-1.8,1.9-2.5c-0.4-5.2-11.9-6-13.5,0.6c-1,4,2.3,5.5,6.9,5.8c9.7,0.6,7.7,7.2,2.9,8.1 c-4,0.7-12,0.1-10-4.8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M278,70.2c0,0,0,7.1,0.1,9c0.2,6.3,8,3.1,8-0.2c0-2.5,0-8.8,0-8.8s0,5.1,0,6.6c0,2.6,0,5.1,0,7.7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M305,70.2c0,0,3,13.3,5,13.3c1.2,0,6.2-10.6,4.8-12.2c-1-1.1-1.5,0.6-0.6,1.8c1.2,1.7,5.1,4.6,11.4,3.8 c5-0.7,6-4.3,3.8-5.4c-2.5-1.2-5.7-0.5-7.5,1.9c-2.6,3.4-2.9,11.1,4.2,10.2c3.3-0.4,8-2.9,10.5-6.2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M336.5,70.3c0,0,0,5.1,0,7.1c0,3.2,1.5,6.2,5.3,4.2c4.1-2.2,4.1-11.2,4.1-11.2s0,5.5,0,17.1 c0,7.4-8.6,7.6-8.6,3.6c0-6.3,8.6-5.1,12.6-4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M366.6,63.8c0.1,7.2-0.1,11.4-0.1,15.6c0,8.1,7.9,1.9,7.9-3.9c0-3,0-5.3,0-5.3c0,6.1,0,6.1,0,11.1 c0,4.8,7.9,0.8,7.9-6.3c0-3.7,0-4.6,0-4.6v24.5c0,0-0.6-17.1,1.9-20.7c3.6-5.3,12.5-2.8,10.7,5.3c-1.2,5.2-9.1,4.9-7.9,1.2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 374.4,
    cy: 66.7,
    r: 2.1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M300.1,75.5c-0.2-6.3-8-3.1-8,0.2c0,2.5,0,8.8,0,8.8s0-5.1,0-6.6c0-2.6,0-5.1,0-7.7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M365.5,61.6c-3.1-0.5-6.8-0.5-9.7,0.5c-0.2,0.1-0.4,0.1-0.5,0.3c-0.2,0.2-0.2,0.6-0.2,0.9 c0.4,6.3-0.6,20.3-0.6,20.3c-1,0,1-9-1-11c-2.2-2.2,6-2,8-1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M484.2,69.5c3.9-6-6.3-9.2-10.1-5.2c-3.7,3.9-0.5,7.5,5.2,8.3c9,1.4,6.3,8,1.5,8.9c-4,0.7-10.9-1.2-7.7-6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M537.5,68.8c0,0,0,7,0.1,8.9c0.2,6.3,8,3.1,8-0.2c0-2.5,0-8.8,0-8.8s0,5,0,6.6c0,2.6,0,5,0,7.6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M563.3,68.9c0,0,3,12.7,5,12.7c1.3,0,6.9-9.7,5.4-11.3c-1-1.1-2.2,0.2-1.2,1.5c1.3,1.7,5.3,5.3,11.6,4.4 c5-0.7,5.3-4,3.8-5.4c-2.1-1.9-5.7-0.5-7.5,1.9c-2.6,3.4-3.4,8.8,3.7,8.9c4.3,0.1,9-1.8,11.5-5.2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M595.5,68.9c0,0,0,5.1,0,7.1c0,7.6,9.5,3.2,9.5,0.1c0-3.9,0-7.1,0-7.1s0,4.4,0,16c0,7.4-8,7.5-8.6,3.6 c-0.8-5,8.6-5.1,12.6-4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M628.9,62c0.1,7.2,0,11.3,0,15.5c0,8.1,7.9,3,7.9-2.8c0-3,0-5.8,0-5.8c0,6.1,0,5.5,0,10.5 c0,4.8,7.9,1.9,7.9-5.2c0-3.7,0-5.3,0-5.3v23.5c0,0-0.6-15.4,1.9-19c3.6-5.3,12.5-3.9,10.7,4.2c-1.2,5.2-9.4,5.3-7.4-0.7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 636.8,
    cy: 64.6,
    r: 2.1
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M559.6,74.1c-0.2-6.3-8-3.1-8,0.2c0,2.5,0,8.8,0,8.8s0-6,0-7.6c0-2.6,0-4,0-6.6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M626.2,63.7c-2.4-0.6-7.7-0.5-11.1-0.1c-0.2,0.1,0.6,18.1,0.6,18.1c-3.8,0.8,1.7-9.7-3.7-9.8 c-1.1-2,9.5-0.5,11.8-0.9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M532,68.6V67c0-3.5-3.3-4.4-6.4-4.4c-3.1,0-6.6,1.1-6.6,4.6s2.5,5.7,6.4,5.7c4.1,0,6.6,0.7,6.6,4.7 s-3.7,4.4-6.6,4.4s-6.4-0.4-6.4-3.9v-1.6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "61.1,382.5 16.1,333.5 114.6,332 73.6,382  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000161624305691060441530000012351052790224664710_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000161624305691060441530000012351052790224664710_)"
    }
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M131.6,341.5c0,0-76.8,0-81.4,0c-11.6,0-11.6,16,0,16c5,0,4.8,0,9.3,0c11.1,0,11.1,15.6,0,15.6 c-3.8,0-21.3,0-21.3,0"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "125,356.1 81.6,356.1 81.6,381.1  "
  })))))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M78.8,585.2c-4.4-0.6-32.3-5.2-32.5-5.3v-12.4c0.9,0.2,17.7,3,24,3.9c1.9,0.3,2.7-0.5,2.7-1.6s-0.2-2.1-2-2.4 c-2.1-0.4-11-1.5-14.6-2.3c-5.9-1.3-10.6-6.8-9.4-15.5c1.9-12.8,12.7-12.9,17.7-12.1c2.9,0.5,19.2,3.1,19.2,3.1l26.2-3.6v11.6 L83.7,553c0,0-18.2-3-20.5-3.2c-2.3-0.3-3.3,0.2-3.4,1.5c-0.1,1.4,0.5,2,2.8,2.3c5.2,0.8,21.1,3.5,21.1,3.5S90,559,90,570.8 C90,580.9,83.4,585.9,78.8,585.2z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 128.2202 276.1114)",
    className: "st3",
    style: {
      fontFamily: "'MicrosoftNewTaiLue-Bold'",
      fontSize: 52
    }
  }, "SurveyFlip"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 128.2203 476.9629)",
    className: "st3",
    style: {
      fontFamily: "'MicrosoftNewTaiLue-Bold'",
      fontSize: 52
    }
  }, "SurveyFlip"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 128.22 577.389)",
    className: "st3",
    style: {
      fontFamily: "'MicrosoftNewTaiLue-Bold'",
      fontSize: 52
    }
  }, "SurveyFlip"), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 75.6,
    y1: 391,
    x2: 75.6,
    y2: 324
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000008868287377905628500000008420810930138102419_",
    points: "53.6,437.4 44.7,457.3 70.3,485.3  77.6,493.2 84.2,485.6 109.7,456.8 100.7,437.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065047313231116078600000005099586018150473651_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008868287377905628500000008420810930138102419_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065047313231116078600000005099586018150473651_)",
      fill: "none",
      stroke: "#6000D6",
      strokeWidth: 17,
      strokeMiterlimit: 10
    },
    points: " 77.6,445.8 58.6,445.8 53.8,456.2 64.7,466.9 78,466.9 82,470.8 77.8,480.7 49.6,508.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000119819787290776607080000003394106942233958329_",
    points: "53.6,437.4 44.7,457.3 70.3,485.3  77.6,493.2 84.2,485.6 109.7,456.8 100.7,437.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000064317781252698889280000007557156926896211862_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119819787290776607080000003394106942233958329_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000064317781252698889280000007557156926896211862_)",
      fill: "none",
      stroke: "#FFB600",
      strokeWidth: 17,
      strokeMiterlimit: 10
    },
    x1: 111.4,
    y1: 445.8,
    x2: 78.2,
    y2: 445.8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000178194605816233946160000006599892566532108714_",
    points: "53.6,437.4 44.7,457.3 70.3,485.3  77.6,493.2 84.2,485.6 109.7,456.8 100.7,437.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003098193170412001130000000292556069426771079_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178194605816233946160000006599892566532108714_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000003098193170412001130000000292556069426771079_)",
      fill: "none",
      stroke: "#FFB600",
      strokeWidth: 17,
      strokeMiterlimit: 10
    },
    points: " 124.9,466.9 87.1,466.8 87.1,498.6  "
  })))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1137.7,271.8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M90.1,559"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.7,
    y: 471,
    className: "st14",
    width: 12,
    height: 12
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.6,
    y: 361.2,
    className: "st14",
    width: 12,
    height: 12
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000183209058788888324690000015282000953582388132_",
    points: "36.8,280.6 45.8,264.1 37.8,263.7  19.3,231.6 117.8,230.1 76.8,280.1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000019645925605649497950000000012677873616908192_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183209058788888324690000015282000953582388132_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000019645925605649497950000000012677873616908192_)",
      fill: "none",
      stroke: "#6000D6",
      strokeWidth: 12,
      strokeMiterlimit: 10
    },
    d: " M134.8,239.6c0,0-76.8,0-81.4,0c-11.6,0-11.6,16,0,16c5,0,4.8,0,9.3,0c11.1,0,11.1,15.6,0,15.6c-3.8,0-37.3,0-37.3,0"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000129924421885664061640000011593942100406363063_",
    points: "36.8,280.6 45.8,264.1 37.8,263.7  19.3,231.6 117.8,230.1 76.8,280.1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000067228589955961847530000009326979787967544496_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000129924421885664061640000011593942100406363063_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000067228589955961847530000009326979787967544496_)",
      fill: "#FFB600"
    },
    points: "88.3,260.4  95.7,260.4 103.3,249.7 79.5,249.7 79.5,278.5 88.3,267.9  "
  })))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "575,557.1 601.2,553 601.2,567.8 587.1,570.2 587.1,584.1 575,586 568.4,585 568.9,556.1  "
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 619.3474 376.5373)",
    className: "st3",
    style: {
      fontFamily: "'MicrosoftNewTaiLue-Bold'",
      fontSize: 52
    }
  }, "SurveyFlip"), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000002383896260496461310000004764652624071382690_",
    points: "552.2,382.5 507.2,333.5 605.7,332  564.7,382  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127030161623684377780000008839482785670181034_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000002383896260496461310000004764652624071382690_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000127030161623684377780000008839482785670181034_)"
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M622.7,341.5c0,0-76.8,0-81.4,0c-11.6,0-11.6,16,0,16c5,0,4.8,0,9.3,0c11,0,11,15.6,0,15.6 c-3.8,0-21.3,0-21.3,0"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st19",
    points: "616.1,356.1 572.7,356.1 572.7,381.1  "
  })))))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M570,585.2c-4.5-0.6-32.3-5.2-32.5-5.3v-12.4c0.9,0.2,17.7,3,24,3.9c2,0.3,2.7-0.5,2.7-1.6s-0.2-2.1-2-2.4 c-2.1-0.4-11-1.5-14.6-2.3c-5.9-1.3-10.6-6.8-9.4-15.5c1.9-12.8,12.7-12.9,17.7-12.1c2.9,0.5,19.2,3.1,19.2,3.1l26.2-3.6v11.6 l-26.4,4.2c0,0-18.2-3-20.5-3.2c-2.3-0.3-3.3,0.2-3.4,1.5c-0.1,1.4,0.5,2,2.8,2.3c5.2,0.8,21.1,3.5,21.1,3.5s6.2,1.9,6.2,13.7 C581.2,580.9,574.6,585.9,570,585.2z"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st17",
    points: "575.1,540.7 601.2,537.1 601.2,548.7 574.8,553  "
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 619.3472 276.1114)",
    className: "st3",
    style: {
      fontFamily: "'MicrosoftNewTaiLue-Bold'",
      fontSize: 52
    }
  }, "SurveyFlip"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 619.3472 476.9629)",
    className: "st3",
    style: {
      fontFamily: "'MicrosoftNewTaiLue-Bold'",
      fontSize: 52
    }
  }, "SurveyFlip"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 619.3469 577.389)",
    className: "st3",
    style: {
      fontFamily: "'MicrosoftNewTaiLue-Bold'",
      fontSize: 52
    }
  }, "SurveyFlip"), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 566.7,
    y1: 391,
    x2: 566.7,
    y2: 324
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000132804298706509197900000000810266750977466036_",
    points: "544.8,437.4 535.8,457.3 561.4,485.3  568.7,493.2 575.3,485.6 600.8,456.8 591.8,437.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183242301413373605570000000992227349191030408_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132804298706509197900000000810266750977466036_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000183242301413373605570000000992227349191030408_)",
      fill: "none",
      stroke: "#6000D6",
      strokeWidth: 17,
      strokeMiterlimit: 10
    },
    points: " 568.7,445.8 549.7,445.8 544.9,456.2 555.8,466.9 569.1,466.9 573.1,470.8 568.9,480.7 540.7,508.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000045598381484651759210000001021909423590514107_",
    points: "544.8,437.4 535.8,457.3 561.4,485.3  568.7,493.2 575.3,485.6 600.8,456.8 591.8,437.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000076577310459470682650000014232914635167908483_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000045598381484651759210000001021909423590514107_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000076577310459470682650000014232914635167908483_)",
      fill: "none",
      stroke: "#FF0000",
      strokeWidth: 17,
      strokeMiterlimit: 10
    },
    x1: 602.5,
    y1: 445.8,
    x2: 569.3,
    y2: 445.8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000166636578158334603980000009619723196230674587_",
    points: "544.8,437.4 535.8,457.3 561.4,485.3  568.7,493.2 575.3,485.6 600.8,456.8 591.8,437.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000148635774735599781320000014437499983089364125_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000166636578158334603980000009619723196230674587_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000148635774735599781320000014437499983089364125_)",
      fill: "none",
      stroke: "#FF0000",
      strokeWidth: 17,
      strokeMiterlimit: 10
    },
    points: " 616,466.9 578.2,466.8 578.2,498.6  "
  })))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M581.2,559"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 579.8,
    y: 471,
    className: "st14",
    width: 12,
    height: 12
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 577.7,
    y: 361.2,
    className: "st14",
    width: 12,
    height: 12
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000161609278963907563050000008989500075924486060_",
    points: "528,280.6 537,264.1 529,263.7 510.5,231.6  609,230.1 568,280.1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083064834653905569260000000363643501693909410_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000161609278963907563050000008989500075924486060_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083064834653905569260000000363643501693909410_)",
      fill: "none",
      stroke: "#6000D6",
      strokeWidth: 12,
      strokeMiterlimit: 10
    },
    d: " M626,239.6c0,0-76.8,0-81.4,0c-11.6,0-11.6,16,0,16c5,0,4.8,0,9.3,0c11,0,11,15.6,0,15.6c-3.8,0-37.3,0-37.3,0"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000115499853022332800720000007509468024498256515_",
    points: "528,280.6 537,264.1 529,263.7 510.5,231.6  609,230.1 568,280.1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000151520592870358659580000006189853985799700397_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000115499853022332800720000007509468024498256515_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000151520592870358659580000006189853985799700397_)",
      fill: "#FF1D25"
    },
    points: " 579.4,260.4 586.8,260.4 594.4,249.7 570.6,249.7 570.6,278.5 579.4,267.9  "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000029021107247859359940000011455635215683018931_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "-113.2,47.2 -92.2,43.9 -92.2,55.7 -103.5,57.7 -103.5,68.8 -113.2,70.3 -118.5,69.5 -118.1,46.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M-117.2,69.7c-3.6-0.5-25.8-4.2-26-4.2v-9.9c0.7,0.2,14.2,2.4,19.2,3.2c1.6,0.2,2.2-0.4,2.2-1.3 s-0.2-1.7-1.6-2c-1.7-0.3-8.8-1.2-11.7-1.8c-4.7-1.1-8.5-5.5-7.5-12.4c1.5-10.2,10.2-10.3,14.2-9.7c2.3,0.4,15.2,2.5,15.2,2.5 l21-2.9v9.3l-21,3.4c0,0-14.6-2.4-16.5-2.6c-1.8-0.2-2.6,0.2-2.7,1.2c0,1.1,0.4,1.6,2.3,1.9c4.2,0.7,16.9,2.8,16.9,2.8 s4.9,1.5,4.9,11C-108.3,66.2-113.6,70.2-117.2,69.7z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st25",
    points: "-113.2,34.1 -92.2,31.2 -92.2,40.5 -113.2,43.9  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "552.8,291 573.8,287.8 573.8,299.5 562.5,301.5 562.5,312.6 552.8,314.1 547.5,313.3 547.9,290.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M548.8,313.5c-3.6-0.5-25.8-4.2-26-4.2v-9.9c0.7,0.2,14.2,2.4,19.2,3.1c1.6,0.2,2.2-0.4,2.2-1.3 s-0.2-1.7-1.6-2c-1.7-0.3-8.8-1.2-11.7-1.8c-4.7-1.1-8.5-5.5-7.5-12.4c1.5-10.2,10.2-10.3,14.2-9.7c2.3,0.4,15.2,2.5,15.2,2.5 l21-2.9v9.3l-21,3.4c0,0-14.6-2.4-16.5-2.6c-1.8-0.2-2.7,0.2-2.7,1.2c0,1.1,0.4,1.6,2.3,1.9c4.2,0.7,16.9,2.8,16.9,2.8 s5,1.5,4.9,11C557.7,310.1,552.5,314,548.8,313.5z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st25",
    points: "552.8,277.9 573.8,275 573.8,284.3 552.8,287.7  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "-113.2,173 -92.2,169.7 -92.2,181.5 -103.5,183.5 -103.5,194.6 -113.2,196.1 -118.5,195.3  -118.1,172.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M-117.2,195.5c-3.6-0.5-25.8-4.2-26-4.2v-9.9c0.7,0.2,14.2,2.4,19.2,3.1c1.6,0.2,2.2-0.4,2.2-1.3 s-0.2-1.7-1.6-1.9c-1.7-0.3-8.8-1.2-11.7-1.8c-4.7-1.1-8.5-5.5-7.5-12.4c1.5-10.2,10.2-10.3,14.2-9.7c2.3,0.4,15.3,2.5,15.3,2.5 l20.9-2.9v9.3l-21.1,3.4c0,0-14.5-2.4-16.4-2.6c-1.8-0.2-2.6,0.2-2.7,1.2c0,1.1,0.4,1.6,2.3,1.9c4.2,0.7,16.9,2.8,16.9,2.8 s4.9,1.5,4.9,10.9C-108.3,192-113.6,196-117.2,195.5z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st29",
    points: "-113.3,159.9 -92.2,157 -92.2,166.3 -113.3,169.7  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "-113.2,298.8 -92.2,295.5 -92.2,307.3 -103.5,309.2 -103.5,320.3 -113.2,321.9 -118.5,321.1  -118.1,298  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M-117.2,321.3c-3.6-0.5-25.8-4.2-26-4.2v-9.9c0.7,0.2,14.2,2.4,19.2,3.1c1.6,0.2,2.2-0.4,2.2-1.3 s-0.2-1.7-1.6-2c-1.7-0.3-8.8-1.2-11.7-1.8c-4.7-1.1-8.5-5.5-7.5-12.4c1.5-10.2,10.2-10.3,14.2-9.7c2.3,0.4,15.2,2.5,15.2,2.5 l21-2.9v9.3l-21,3.4c0,0-14.6-2.4-16.5-2.6c-1.8-0.2-2.6,0.2-2.7,1.2c0,1.1,0.4,1.6,2.3,1.9c4.2,0.7,16.9,2.8,16.9,2.8 s4.9,1.5,4.9,11C-108.3,317.8-113.6,321.8-117.2,321.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "356.5,298.8 377.5,295.5 377.5,307.3 366.1,309.2 366.1,320.3 356.5,321.9 351.2,321.1 351.6,298  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M352.5,321.3c-3.6-0.5-25.8-4.2-26-4.2v-9.9c0.7,0.2,14.2,2.4,19.2,3.1c1.6,0.2,2.1-0.4,2.1-1.3 s-0.1-1.7-1.6-2c-1.7-0.3-8.8-1.2-11.6-1.8c-4.7-1.1-8.5-5.5-7.5-12.4c1.5-10.2,10.2-10.3,14.2-9.7c2.3,0.4,15.2,2.5,15.2,2.5 l21-2.9v9.3l-21,3.4c0,0-14.6-2.4-16.5-2.6c-1.8-0.2-2.6,0.2-2.7,1.2c0,1.1,0.4,1.6,2.3,1.9c4.2,0.7,16.9,2.8,16.9,2.8 s5,1.5,4.9,11C361.4,317.8,356.1,321.8,352.5,321.3z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st30",
    points: "356.5,285.7 377.5,282.8 377.5,292.1 356.5,295.5  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "356.5,124.3 377.5,121 377.5,132.8 366.1,134.7 366.1,145.8 356.5,147.4 351.2,146.6 351.6,123.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M352.5,146.8c-3.6-0.5-25.8-4.2-26-4.2v-9.9c0.7,0.2,14.2,2.4,19.2,3.1c1.6,0.2,2.1-0.4,2.1-1.3 s-0.1-1.7-1.6-1.9c-1.7-0.3-8.8-1.2-11.6-1.8c-4.7-1.1-8.5-5.5-7.5-12.4c1.5-10.2,10.2-10.3,14.2-9.7c2.3,0.4,15.2,2.5,15.2,2.5 l21-2.9v9.3l-21,3.4c0,0-14.6-2.4-16.5-2.6c-1.8-0.2-2.6,0.2-2.7,1.2c0,1.1,0.4,1.6,2.3,1.9c4.2,0.7,16.9,2.8,16.9,2.8 s5,1.5,4.9,11C361.4,143.3,356.1,147.3,352.5,146.8z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st25",
    points: "356.5,111.1 377.5,108.3 377.5,117.6 356.5,120.9  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "356.5,219.6 377.5,216.3 377.5,228.1 366.1,230 366.1,241.1 356.5,242.7 351.2,241.9 351.6,218.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M352.5,242.1c-3.6-0.5-25.8-4.2-26-4.2V228c0.7,0.2,14.2,2.4,19.2,3.1c1.6,0.2,2.1-0.4,2.1-1.3 s-0.1-1.7-1.6-1.9c-1.7-0.3-8.8-1.2-11.6-1.8c-4.7-1.1-8.5-5.5-7.5-12.4c1.5-10.2,10.2-10.3,14.2-9.7c2.3,0.4,15.2,2.5,15.2,2.5 l21-2.9v9.3l-21,3.4c0,0-14.6-2.4-16.5-2.6c-1.8-0.2-2.6,0.2-2.7,1.2c0,1.1,0.4,1.6,2.3,1.9c4.2,0.7,16.9,2.8,16.9,2.8 s5,1.5,4.9,10.9C361.4,238.6,356.1,242.6,352.5,242.1z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st25",
    points: "356.5,206.4 377.5,203.6 377.5,212.9 356.5,216.3  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "488,-78.9 509,-82.1 509,-70.3 497.6,-68.4 497.6,-57.3 488,-55.8 482.7,-56.5 483.1,-79.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M484-56.4c-3.6-0.5-25.8-4.2-26-4.2v-9.9c0.7,0.2,14.2,2.4,19.2,3.2c1.6,0.2,2.1-0.4,2.1-1.3 s-0.1-1.7-1.6-1.9c-1.7-0.3-8.8-1.2-11.6-1.8c-4.7-1.1-8.5-5.5-7.5-12.4c1.5-10.2,10.2-10.3,14.2-9.7C475.1-94.1,488-92,488-92 l21-2.9v9.3l-21,3.4c0,0-14.6-2.4-16.5-2.6c-1.8-0.2-2.6,0.2-2.7,1.2c0,1.1,0.4,1.6,2.3,1.9c4.2,0.7,16.9,2.8,16.9,2.8 s5,1.5,4.9,10.9C492.9-59.8,487.6-55.8,484-56.4z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st34",
    points: "488,-92 509,-94.9 509,-85.6 488,-82.2  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "-113.2,409.9 -92.2,406.7 -92.2,418.5 -103.5,420.4 -103.5,431.5 -113.2,433 -118.5,432.2  -118.1,409.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M-117.2,432.4c-3.6-0.5-25.8-4.2-26-4.2v-9.9c0.7,0.2,14.2,2.4,19.2,3.1c1.6,0.2,2.2-0.4,2.2-1.3 s-0.2-1.7-1.6-2c-1.7-0.3-8.8-1.2-11.7-1.8c-4.7-1.1-8.5-5.5-7.5-12.4c1.5-10.2,10.2-10.3,14.2-9.7c2.3,0.4,15.2,2.5,15.2,2.5 l21-2.9v9.3l-21,3.4c0,0-14.6-2.4-16.5-2.6c-1.8-0.2-2.6,0.2-2.7,1.2c0,1.1,0.4,1.6,2.3,1.9c4.2,0.7,16.9,2.8,16.9,2.8 s4.9,1.5,4.9,11C-108.3,429-113.6,432.9-117.2,432.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "356.5,-78.9 377.5,-82.1 377.5,-70.3 366.1,-68.4 366.1,-57.3 356.5,-55.8 351.2,-56.5 351.6,-79.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M352.5-56.4c-3.6-0.5-25.8-4.2-26-4.2v-9.9c0.7,0.2,14.2,2.4,19.2,3.2c1.6,0.2,2.1-0.4,2.1-1.3 s-0.1-1.7-1.6-1.9c-1.7-0.3-8.8-1.2-11.6-1.8c-4.7-1.1-8.5-5.5-7.5-12.4c1.5-10.2,10.2-10.3,14.2-9.7c2.3,0.4,15.2,2.5,15.2,2.5 l21-2.9v9.3l-21,3.4c0,0-14.6-2.4-16.5-2.6c-1.8-0.2-2.6,0.2-2.7,1.2c0,1.1,0.4,1.6,2.3,1.9c4.2,0.7,16.9,2.8,16.9,2.8 s5,1.5,4.9,10.9C361.4-59.8,356.1-55.8,352.5-56.4z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st39",
    points: "356.5,-92 377.5,-94.9 377.5,-85.6 356.5,-82.2  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "356.5,12.3 377.5,9.1 377.5,20.9 366.1,22.8 366.1,33.9 356.5,35.4 351.2,34.6 351.6,11.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M352.5,34.8c-3.6-0.5-25.8-4.2-26-4.2v-9.9c0.7,0.2,14.2,2.4,19.2,3.1c1.6,0.2,2.1-0.4,2.1-1.3 s-0.1-1.7-1.6-2c-1.7-0.3-8.8-1.2-11.6-1.8c-4.7-1.1-8.5-5.5-7.5-12.4c1.5-10.2,10.2-10.3,14.2-9.7c2.3,0.4,15.2,2.5,15.2,2.5 l21-2.9v9.3l-21,3.4c0,0-14.6-2.4-16.5-2.6c-1.8-0.2-2.6,0.2-2.7,1.2c0,1.1,0.4,1.6,2.3,1.9c4.2,0.7,16.9,2.8,16.9,2.8 s5,1.5,4.9,10.9C361.4,31.4,356.1,35.3,352.5,34.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "-113.2,-78.6 -92.2,-81.8 -92.2,-70.1 -103.5,-68.1 -103.5,-57 -113.2,-55.5 -118.5,-56.3  -118.1,-79.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M-117.2-56.1c-3.6-0.5-25.8-4.2-26-4.2v-9.9c0.7,0.2,14.2,2.4,19.2,3.2c1.6,0.2,2.2-0.4,2.2-1.3 s-0.2-1.7-1.6-1.9c-1.7-0.3-8.8-1.2-11.7-1.8c-4.7-1.1-8.5-5.5-7.5-12.4c1.5-10.2,10.2-10.3,14.2-9.7c2.3,0.4,15.2,2.5,15.2,2.5 l21-2.9v9.3l-21,3.4c0,0-14.6-2.4-16.5-2.6c-1.8-0.2-2.6,0.2-2.7,1.2c0,1.1,0.4,1.6,2.3,1.9c4.2,0.7,16.9,2.8,16.9,2.8 s4.9,1.5,4.9,10.9C-108.3-59.5-113.6-55.6-117.2-56.1z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st42",
    points: "-113.2,-91.7 -92.2,-94.6 -92.2,-85.3 -113.2,-81.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M-108.3-77.1"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M-62.4-59.3c0-2.7,0-5.2,0-7.9c0.7,0,1.4,0,2.1,0c5.5,0,11.1,0,16.6,0c3.3,0,4.2-0.8,4.2-4.2 c0-0.7,0-1.4,0-2.3c-7.7,0-15.2,0-22.8,0c0-4.3-0.4-8.4,0.1-12.4c0.6-5.1,5-8.7,10.1-8.7c7.8-0.1,15.7,0,23.6,0c0,2.5,0,5,0,7.7 c-0.7,0-1.4,0-2,0c-5.2,0-10.5,0-15.7,0c-4.5,0-5.6,1.3-5,6.1c7.5,0,15.1,0,22.6,0c0,4.5,0.4,8.9-0.1,13.2 c-0.5,4.7-4.7,8.3-9.9,8.5C-46.4-59.1-54.3-59.3-62.4-59.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M174.9-60.8c0,5.1,0,9.7,0,14.4c-3.1,0-6,0-9.1,0c0-12.9,0-25.8,0-39c3.8,0,7.4-0.1,11.1,0 c2.6,0.1,5.4,0,7.9,0.7c6,1.7,8.9,6.3,8.8,12.9c-0.2,5.9-3.9,10.9-9.6,12.3C180.9-58.6,177.8-58,174.9-60.8z M174.3-77.7 c0,1.6,0,2.8,0,4c0,0.8,0,1.5,0.1,2.3c0.4,2.6,2.5,4.4,5.2,4.4c2.8,0,4.9-1.9,5.2-4.6c0.3-2.9-1.1-5.2-3.8-5.7 C178.9-77.6,176.8-77.6,174.3-77.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M93.6-71.7c1.2-4,2.1-7.5,3.2-10.9c1-3.2,0.1-2.7,3.7-2.7c2.2,0,4.3,0,6.9,0c-4.5,13.2-8.9,26.1-13.3,39 c-3.1,0-6,0-9.2,0C86-50,87-53.6,88.3-57.2c0.5-1.5,0.5-2.8-0.1-4.2c-2.7-7.2-5.2-14.5-7.8-21.8c-0.2-0.7-0.4-1.3-0.7-2.2 c3.1,0,5.9-0.1,8.8,0.1c0.5,0,1.1,0.7,1.3,1.2c1.1,3.3,2.1,6.7,3.1,10.1C93-73.4,93.2-72.8,93.6-71.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M60-69.4c1.1,3.6,3.5,4.8,6.5,4c1.8-0.5,3.7-0.8,5.5-0.9c1.7-0.2,3.4,0,5.5,0c-0.5,0.9-0.7,1.5-1.1,2.1 c-2.9,4.4-9.2,6.6-15.2,5.3c-5.5-1.2-9-4.5-10.2-10.1c-1.7-7.6,2.4-14.7,9.4-16.5c8.1-2.1,15.7,1.8,17.7,9.1 c0.5,1.8,0.4,3.7,0.6,5.5c0.1,1.2-0.5,1.7-1.7,1.6c-4.9-0.1-9.8,0-14.7,0C61.5-69.4,60.8-69.4,60-69.4z M60.1-75c3,0,6,0,9,0 c-0.2-2.5-1.9-3.9-4.5-3.9S60.2-77.4,60.1-75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M119.5-81.2c3.8,0,7.4,0,11.2,0c0,2.4,0,4.8,0,7.3c-3.7,0-7.4,0-11.3,0c0,4.9,0,9.7,0,14.5 c-3.3,0-6.4,0-9.7,0c-0.1-0.5-0.1-1.1-0.1-1.6c0-9,0-18,0-27c0-5.7,1.6-7.2,7.3-7.2c4.6,0,9.2,0,13.9,0c0,2.7,0,5.2,0,7.9 c-3.7,0-7.4,0-11.2,0C119.5-85.2,119.5-83.3,119.5-81.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M-23.4-85.3c3.1,0,6,0,9.1,0c0,3.2,0,6.3,0,9.4c0,1,0,2,0,3.1c0,4.7,1.4,5.9,6.5,5.3c0-5.9,0-11.8,0-17.8 c3.1,0,6,0,9.1,0c0,8.6,0,17.1,0,26.2c-5.4-0.2-10.8,0-16.1-0.8c-5-0.7-8.3-5.1-8.5-10.4C-23.6-75.2-23.4-80.1-23.4-85.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M49.6-85.4c-1.3,4.1-2.5,7.9-3.8,11.7c-1.4,4.3-2.8,8.6-4.1,12.9c-0.3,1.1-0.8,1.5-2,1.5 c-2.2-0.1-4.3,0-6.5-0.1c-0.6,0-1.5-0.6-1.6-1.1c-2.7-8.1-5.3-16.2-7.9-24.4c0-0.1,0-0.2,0-0.5c2.9,0,5.8,0,9,0 c1.2,4.7,2.4,9.5,3.6,14.3c0.1,0,0.2,0,0.3,0.1c0.3-1,0.6-2,0.8-3c0.9-3.4,1.7-6.8,2.6-10.2c0.2-0.5,1-1.2,1.5-1.2 C44.2-85.4,46.7-85.4,49.6-85.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M136.3-95.2c3,0,5.9,0,8.9,0c0,11.9,0,23.8,0,35.7c-2.9,0-5.8,0-8.9,0C136.3-71.2,136.3-83.1,136.3-95.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M7.4-85.3c4.9,0,9.7,0,14.5,0c0,2.8,0,5.5,0,8.5c-1.7,0-3.5,0-5.4,0c0,5.9,0,11.6,0,17.3c-3.1,0-6.1,0-9.1,0 C7.4-67.9,7.4-76.5,7.4-85.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M160.2-59.3c-3,0-5.9,0-8.9,0c0-8.6,0-17.2,0-25.9c2.9,0,5.9,0,8.9,0C160.2-76.7,160.2-68.1,160.2-59.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M151.3-95.1c3,0,5.9,0,8.9,0c0,2.1,0,4.1,0,6.3c-2.9,0-5.9,0-8.9,0C151.3-90.9,151.3-92.9,151.3-95.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M165.9,43.5c3,0,5.7,0,8.4,0c0.2,0.6,0.3,1,0.4,1.6c0.5-0.1,0.9-0.2,1.3-0.4c2.9-1,5.8-1.6,8.9-1.1 c7.2,1.1,10.7,7.7,7.4,14.2c-2.6,5.1-7.2,7.7-12.3,9.6c-1.5,0.6-3.1,0.9-4.7,1.4c-0.4-1.2-0.8-2.1-1.1-3c-0.1,0-0.2,0-0.3,0 c-0.2,4.2-0.4,8.4-0.6,12.6c-3,0-5.8,0-8.7,0C165,66.6,165.5,55.1,165.9,43.5z M174.2,61.7c0.5-0.1,0.9-0.2,1.2-0.3 c3.7-1.2,7.2-2.6,9.4-6c0.6-0.9,0.8-2.6,0.4-3.2c-0.6-0.8-2.2-1.3-3.3-1.1c-1.8,0.3-3.5,1.2-5.3,1.8c-0.8,0.3-1.6,0.6-2.5,0.9 C174.2,56.3,174.2,58.9,174.2,61.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M118.5,42.5c-0.1,1.7-0.2,3.4-0.2,5.4c5.1,0,10,0,15.1,0c-0.2,2.5-0.4,4.7-0.5,6.9c-4.9,0-9.6,0-14.5,0 c0,4.6,0,9.2,0,14.1c-3.2,0.3-6.4,0.7-10,1c-0.8-12.2-0.6-24,0.6-36.2c3.6,0.7,7.2-0.1,10.5,1.6c0.5,0.2,1.1,0.1,1.7,0.1 c4.4,0,8.9,0,13.6,0c-0.2,2.7-0.4,5-0.5,7.2C129,42.5,123.9,42.5,118.5,42.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M-36.9,35.5c-0.9,2.4-1.8,4.5-2.5,6.5c-3-0.5-5.8-1-8.6-1.3c-1.5-0.2-3.4-0.2-4.2,1.4 c-0.9,1.7,0.2,3.2,1.3,4.4c2.1,2.2,4.3,4.2,6.5,6.3c1.2,1.1,2.5,2.2,3.5,3.5c3,3.9,2,8.9-2.3,11.3c-4,2.3-8.3,2.4-12.6,1 c-2.2-0.7-4.2-1.9-6.5-3c1.9-2.2,3.5-4.1,5.1-6c1.5,0.9,2.9,1.8,4.3,2.5c1.4,0.7,3,1.4,4.4,0.2c0.9-0.8-0.1-2.4-1.9-4 c-2.8-2.5-5.6-5.1-8.1-7.9c-2.2-2.5-3.5-5.6-3-9c0.3-2.8,2.1-4.6,4.6-5.8c4.2-2,8.7-1.9,13.1-1.3C-41.6,34.3-39.4,34.9-36.9,35.5z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M83.8,42.8c2.1,5.4,4.1,10.8,6.3,16.5c0.5-1.1,0.9-1.8,1.2-2.6c1.8-4,3.6-8,5.3-12.1c0.5-1.3,1.1-1.5,2.4-1 c2.1,0.7,4.2,1.3,6.6,2c-4.9,11.2-9.8,22.4-14.7,33.6c-2.7-0.8-5.4-1.6-8.3-2.4c1.4-3.3,2.8-6.6,4.3-9.9c-3.2,0.1-3.2,0.1-4.4-3 c-2.1-5.5-4.2-11-6.3-16.6c-0.2-0.6-0.4-1.3-0.7-2.1C78.3,44.3,81,43.6,83.8,42.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M-34,42.7c3.4,0.6,6.1,1,9,1.5c-0.4,2.6-0.9,5.2-1.2,7.7c-0.2,2-0.4,4.2-0.2,6.2c0.3,3,1.9,3.9,4.7,2.9 c0.2-0.1,0.5-0.2,0.7-0.3c2.3-0.8,3.6-2,3.3-4.8c-0.3-4.1-0.1-8.2-0.1-12.4c3.3,0,6.2,0,9.3,0C-8.7,52-8.9,60.3-9.1,68.7 c-3,0-5.8,0-8.8,0c0-0.9,0-1.8,0-2.9c-0.6,0.2-1.1,0.3-1.5,0.5c-1.6,0.7-3.2,1.4-4.9,2c-5,1.6-8.9-0.3-10.5-5.4 c-0.6-1.8-0.9-3.8-0.8-5.8C-35,52.5-34.5,47.8-34,42.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M73.4,56.9c-5.2,0.8-10.9,1.6-16.9,2.5c1.5,2.8,3.8,3.3,6.2,3.1c2.4-0.2,4.7-0.6,7.1-1c0,2.2,0,4.5,0,7.2 c-2.4,0.3-4.8,0.7-7.3,0.8c-3.3,0.1-6.6-0.4-9.6-2.1c-4.3-2.4-6.2-6.2-5.2-11.1c1.2-5.7,5.1-9.4,9.4-12.8c0.3-0.3,1-0.3,1.4-0.3 c3.6,0,7.2-0.1,10.8,0c0.7,0,1.7,0.5,1.9,1c1.3,3,2.4,6.2,3.6,9.3c0.1,0.3,0.1,0.8-0.1,1C74.5,55.3,74,55.9,73.4,56.9z M63.8,47.7 c-0.2-0.1-0.5-0.1-0.7-0.2c-1.8,2-3.6,4-5.4,6c0.1,0.2,0.2,0.3,0.4,0.5c2.5-0.4,4.9-0.7,7.7-1.1C65,51,64.4,49.4,63.8,47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M27.2,42.7c1.7,5.4,3.4,10.7,5.2,16.4c2.6-5.7,5.1-11,7.6-16.5c2.6,1,5.1,2,7.8,3.1 c-4.1,7.6-8.1,15.1-12.2,22.5c-0.2,0.3-0.5,0.7-0.8,0.7c-2,0.2-4,0.3-6,0.4c-0.4,0-0.9-0.6-1.1-1c-2.9-7.6-5.8-15.3-8.8-23.1 C21.7,44.3,24.3,43.6,27.2,42.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M4.7,68.8c-3.1,0-6,0-8.9,0c0.4-8.4,0.8-16.7,1.3-25.3c2.8,0,5.7,0,8.7,0c0.1,0.9,0.1,1.9,0.2,3.2 c2.8-2.6,5.8-4.2,9.3-2.6c3,1.4,4.2,4.3,5.4,7.5c-2.7,0.5-5.3,1-7.9,1.4c-0.4,0.1-1-0.5-1.4-0.9c-1.4-1.7-2.6-1.8-3.3,0.3 c-1.2,3.4-1.9,6.9-2.6,10.4C5,64.7,4.9,66.7,4.7,68.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M146,69.1c-2.9,0-5.7,0-9,0c0.7-11.8,1.4-23.4,2.1-35.2c3.1,0.2,6,0.4,9,0.6C147.4,46.1,146.7,57.6,146,69.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M160.6,43.8c-0.3,8.4-0.6,16.6-0.9,25c-2.8,0-5.7,0-9,0c0.4-8.5,0.7-17,1.1-25.8 C154.8,43.3,157.6,43.5,160.6,43.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M161.8,32.4c-0.3,2.6-0.6,4.9-0.9,7.1c-2.8,0-5.6,0-8.7,0c0.3-2.8,0.6-5.4,1-8.2 C156.1,31.7,158.8,32,161.8,32.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M-31.5,170.9c-3.3,0-6.4,0-9.5,0c-1.5-3.6-6.8-5-10-2.8c-1.2,0.9-1.3,2.5,0.1,3.3c1.3,0.8,2.7,1.3,4.2,1.7 c2.8,0.8,5.7,1.4,8.6,2.2c1.1,0.3,2.2,0.9,3.3,1.5c5.8,3.3,4.4,11,0.2,13.3c-2.2,1.2-4.7,2-7.1,2.4c-4.5,0.7-9,0.6-13.4-0.9 c-4.7-1.6-7.2-4.8-7.3-9.2c3.3,0,6.6,0,9.9,0c1.7,3.6,7.3,5.3,10.7,3c1.5-1,1.5-2.8-0.2-3.6c-1.5-0.8-3.3-1.2-4.9-1.7 c-3-0.9-6.1-1.5-9-2.6c-3.1-1.2-5.5-3.2-5.6-7c-0.1-3.3,1.4-5.7,4.3-7.1c4.5-2.2,9.3-2.6,14.2-1.9c2.7,0.4,5.4,1.3,7.8,2.5 C-32.5,165.1-31.3,167.7-31.5,170.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M177.6,200.5c-2.6,0-5.1,0-7.6,0c0-10.2,0-20.3,0-30.6c2.5,0,5,0,7.6,0c0.1,1,0.2,2,0.3,3.5 c3.4-4.3,7.8-4.5,12.3-3.9c2.8,0.4,5.1,1.7,6.9,4c3.6,4.8,2.9,12.3-1.3,16.2c-3.8,3.5-13.3,4.6-18.2-1.2c0,2.3,0,4.1,0,6 C177.6,196.6,177.6,198.5,177.6,200.5z M190.8,181.1c0-3.2-2.4-5.4-5.9-5.4c-3.4,0-5.8,2.1-5.8,5.1c-0.1,3.3,2.1,5.5,5.7,5.6 C188.3,186.5,190.8,184.3,190.8,181.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M112.3,161.4c8.8,0,17.4,0,26.1,0c0.3,0,0.6,0.1,1,0.1c0,2.2,0,4.4,0,6.7c-6.1,0-12,0-18.1,0 c0,1.8,0,3.4,0,5.1c6,0,11.9,0,18.1,0c0,2.1,0,4.1,0,6.3c-6,0-12,0-18.2,0c0,4.4,0,8.4,0,12.5c-3,0-5.8,0-8.8,0 C112.3,182,112.3,171.8,112.3,161.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M79.8,182.5c-6.5,0-13,0-19.5,0c0.3,1.9,1.4,3,2.9,3.6c2.8,1.2,5.8,0.5,7.8-1.8c0.3-0.3,0.8-0.6,1.2-0.6 c2.3-0.1,4.7,0,7.6,0c-0.8,1.7-1.3,3.2-2.2,4.5c-1.6,2.2-3.9,3.4-6.5,4.1c-3.6,0.9-7.3,0.9-10.9-0.2c-5-1.6-8-5.6-7.9-10.9 c0-5.4,2.8-9.3,7.9-10.9c3.7-1.2,7.5-1.2,11.2-0.1C77.1,171.6,79.9,175.7,79.8,182.5z M71.2,178.1c-1.8-2.6-4.1-2.8-6.6-2.5 c-1.6,0.2-3.1,0.7-4,2.5C64.2,178.1,67.5,178.1,71.2,178.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M86.2,203.5c1.3-3.3,2.4-6.4,3.7-9.3c0.6-1.4,0.5-2.6-0.1-3.9c-2.9-6.1-5.7-12.3-8.5-18.5 c-0.3-0.6-0.5-1.2-0.8-2c2.9,0,5.6-0.1,8.3,0.1c0.4,0,1,0.7,1.2,1.2c1.4,3.6,2.8,7.2,4.2,10.8c0.2,0.5,0.5,1.1,0.9,2 c1.5-4.1,3-7.8,4.2-11.6c0.6-1.9,1.5-2.9,3.7-2.6c2,0.2,4.1,0.1,6.4,0.1c-0.5,1.3-1,2.4-1.5,3.5c-4.1,9.6-8.3,19.2-12.4,28.8 c-0.5,1.1-1.1,1.5-2.2,1.5C90.9,203.5,88.7,203.5,86.2,203.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M-26.8,169.9c3,0,5.5,0,8.2,0c0,3.8,0,7.6,0,11.3c0,3.2,2.7,5.1,5.8,4.1c1.8-0.6,2.9-2,2.9-4.1 c0-3.7,0-7.4,0-11.2c2.7,0,5.2,0,7.9,0c0,7.4,0,14.8,0,22.2c-2,0-4,0-6.1,0c-0.1-0.9-0.2-1.7-0.4-2.8c-3.1,2.7-6.5,3.7-10.3,3 c-4.1-0.8-6.8-3-7.3-7.2C-26.7,180.2-26.6,175.1-26.8,169.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M22.3,169.8c2.9,0,5.5-0.1,8.1,0.1c0.5,0,1.2,0.6,1.4,1.1c1.5,3.9,2.8,7.8,4.2,11.8c0.2,0.6,0.4,1.1,0.8,2.1 c0.8-2.1,1.4-3.7,2-5.4c1-2.8,2-5.7,3.1-8.5c0.2-0.5,0.8-1.1,1.3-1.1c2.6-0.1,5.3-0.1,8.2-0.1c-0.6,1.4-1.1,2.6-1.6,3.8 c-2.4,5.8-4.9,11.6-7.3,17.4c-0.4,1-1,1.3-2,1.3c-2.5-0.1-5.1,0-7.6-0.1c-0.5,0-1.4-0.4-1.5-0.8C28.4,184.4,25.5,177.2,22.3,169.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M10.4,192.2c-2.7,0-5.1,0-7.7,0c0-7.4,0-14.8,0-22.3c2,0,4,0,6.2,0c0.1,1.6,0.3,3.1,0.4,5.1 c3.2-4.5,7.5-5.4,12.5-5.2c0,2,0.1,3.9-0.1,5.8c0,0.3-0.7,0.8-1.2,0.9c-1.2,0.2-2.4,0.2-3.6,0.5c-4.6,0.9-6.6,3.3-6.6,8.1 C10.4,187.4,10.4,189.7,10.4,192.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M143.8,161.5c2.6,0,5.1,0,7.7,0c0,10.2,0,20.4,0,30.7c-2.6,0-5.1,0-7.7,0C143.8,182,143.8,171.8,143.8,161.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M157,192.2c0-7.4,0-14.8,0-22.2c2.5,0,5,0,7.6,0c0,7.4,0,14.8,0,22.2C162.1,192.2,159.7,192.2,157,192.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M160.8,158.8c2.4,0,4.3,1.8,4.3,4.1c0,2.2-2,4.2-4.3,4.2s-4.3-1.9-4.3-4.2 C156.6,160.6,158.4,158.8,160.8,158.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M-33,299.9c-4-2.7-8.1-4.5-12.5-5.3c-2.2-0.4-4.4-0.3-6.6-0.3c-0.5,0-1.4,0.8-1.4,1.2c0,0.5,0.6,1.4,1.1,1.6 c2.3,0.8,4.6,1.4,6.9,2.2c2.9,1,5.9,1.7,8.6,3c3.3,1.6,5.2,4.4,4.9,8.3c-0.3,3.7-2.5,6-5.7,7.5c-0.9,0.4-1.9,0.8-2.8,1 c-7.1,1.7-13.8,0.4-20.1-3.1c-1-0.6-1.5-1.3-1.5-2.5c0.1-2.2,0-4.5,0-7c0.5,0.2,0.8,0.4,1.1,0.6c4.1,2.8,8.6,4.7,13.6,5.2 c1.7,0.2,3.4-0.2,5-0.5c0.6-0.1,1.4-0.9,1.5-1.5c0-0.7-0.5-1.7-1-2c-1.4-0.8-2.9-1.3-4.4-1.8c-2.9-0.9-5.8-1.6-8.6-2.6 c-1.6-0.5-3.2-1.4-4.5-2.4c-4.2-3.2-3.9-9.2,0.5-12.1c3-2,6.4-2.3,9.8-2.3c5.2,0,10,1.5,14.6,3.8c1,0.5,1.5,1,1.5,2.3 C-33.1,295.3-33,297.4-33,299.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M3.2,296.2c2.5,0,4.9,0,7.4,0c0.1,1.7,0.2,3.3,0.4,5.4c2.9-4.7,6.9-5.7,11.6-5.5c2.5,0.1,5,0.1,7.5,0 c1,0,1.4,0.3,1.8,1.3c1.4,4.3,3,8.6,4.5,12.9c0.2,0.6,0.5,1.2,0.8,2.2c1.8-5.2,3.5-9.9,5.1-14.6c0.4-1.3,1-1.8,2.3-1.7 c2.3,0.1,4.7,0,7.3,0c-1.1,2.6-2,4.9-3,7.2c-2,4.9-4.1,9.7-6.1,14.6c-0.4,1-0.9,1.3-1.9,1.3c-2.4-0.1-4.7-0.1-7.1,0 c-1.2,0-1.9-0.4-2.3-1.5c-2.7-6.5-5.4-13-8.2-19.5c-0.1-0.3-0.3-0.6-0.7-1c0,1.8,0,3.6,0,5.5c-1.9,0.3-3.6,0.4-5.3,0.8 c-4,0.9-5.6,2.7-5.9,6.9c-0.2,2.8,0,5.7,0,8.6c-2.8,0-5.3,0-8,0C3.2,311.5,3.2,303.9,3.2,296.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M177.6,315.8c0,4,0,7.9,0,11.9c-2.8,0-5.3,0-8,0c0-10.5,0-20.9,0-31.4c2.6,0,5.1,0,7.7,0 c0.1,1.1,0.2,2.1,0.3,3.4c0.8-0.8,1.4-1.5,2.2-2c6.5-5,16.3-1.3,17.6,6.8c0.4,2.3,0.4,4.8-0.1,7c-1.4,6.8-6.6,8.7-12.9,7.9 c-1.2-0.2-2.5-0.7-3.6-1.3C179.6,317.6,178.8,316.7,177.6,315.8z M189.3,307.7c0-3.5-2.1-5.5-5.7-5.6c-3.7,0-6.1,2-6.1,5.4 c0,3.5,2.2,5.6,5.9,5.6C187.1,313.1,189.3,311.1,189.3,307.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M111.4,319.1c0-10.5,0-20.9,0-31.4c9.3,0,18.5,0,27.9,0c0,2.2,0,4.3,0,6.7c-6.2,0-12.4,0-18.8,0 c0,1.8,0,3.2,0,4.9c6.3,0,12.5,0,18.7,0c0,2.1,0,4.1,0,6.4c-6.2,0-12.4,0-18.8,0c0,4.6,0,9,0,13.4 C117.4,319.1,114.5,319.1,111.4,319.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M60.2,309.2c0.5,2.6,2.2,3.9,4.8,4c4.1,0.2,7.9-0.8,11.7-2.3c0.8-0.3,1.5-0.6,2.4-1c0,1.7,0.1,3.2,0,4.6 c-0.1,0.5-0.5,1.2-0.9,1.5c-5.6,3.4-11.6,4.6-18,2.8c-5.5-1.6-8.5-6.5-7.9-12.5c0.6-5.9,4.4-10,10.1-10.5c2.6-0.2,5.3-0.2,7.9,0.3 c6.2,1.4,9.5,6.4,8.7,13C72.8,309.2,66.5,309.2,60.2,309.2z M60.7,304.3c3.3,0,6.5,0,9.8,0C68.1,301,62.7,301,60.7,304.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M108.7,296.1c-0.3,0.8-0.5,1.3-0.7,1.8c-4.2,9.4-8.4,18.8-12.5,28.2c-0.5,1.2-1.1,1.7-2.5,1.6 c-2.1-0.1-4.1,0-6.5,0c1-2.5,1.8-4.7,2.8-7c0.5-1.1,0.4-2-0.1-3.2c-3.1-6.5-6.2-13-9.2-19.5c-0.3-0.6-0.5-1.1-0.9-1.9 c2.8,0,5.3-0.1,7.8,0.1c0.5,0,1.2,0.7,1.4,1.2c1.8,4.4,3.6,8.8,5.3,13.1c0.2,0.4,0.3,0.7,0.7,1.4c0.7-1.8,1.3-3.3,1.9-4.8 c1.2-3.3,2.5-6.5,3.7-9.8c0.3-0.9,0.8-1.3,1.8-1.2C103.9,296.2,106.2,296.1,108.7,296.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M-1.9,319.2c-2.3,0-4.5,0-6.9,0c0-1.4,0-2.8,0-4.1c-2.2,2.3-4.6,3.9-7.6,4.3c-5.6,0.8-9.7-1.6-10.1-7 c-0.4-5.3-0.1-10.7-0.1-16.2c2.3,0,4.8,0,7.6,0c0,3.2,0,6.4,0,9.6c0,0.7,0,1.4,0,2.1c0.1,2.5,1,4,3,4.5c2.3,0.5,4.6-0.3,5.6-2.4 c0.5-1,0.8-2.2,0.8-3.4c0.1-3.4,0-6.9,0-10.4c2.6,0,5.1,0,7.8,0C-1.9,303.8-1.9,311.4-1.9,319.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M143.6,287.7c2.7,0,5.2,0,7.9,0c0,10.5,0,20.9,0,31.4c-2.6,0-5.2,0-7.9,0 C143.6,308.7,143.6,298.3,143.6,287.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M164.6,296.3c0,7.6,0,15.2,0,22.8c-2.6,0-5.2,0-7.9,0c0-7.6,0-15.1,0-22.8 C159.3,296.3,161.9,296.3,164.6,296.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M156.8,286.6c2.6,0,5.1,0,7.8,0c0,2,0,4,0,6.1c-2.5,0-5.1,0-7.8,0C156.8,290.6,156.8,288.7,156.8,286.6z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M624.4,287.3c-4-2.7-8.1-4.5-12.5-5.3c-2.2-0.4-4.4-0.3-6.6-0.3c-0.5,0-1.4,0.8-1.4,1.2 c0,0.5,0.6,1.4,1.1,1.6c2.3,0.8,4.6,1.4,6.9,2.2c2.9,1,5.9,1.7,8.7,3c3.3,1.6,5.2,4.4,4.9,8.3c-0.3,3.7-2.5,6-5.7,7.5 c-0.9,0.4-1.9,0.8-2.8,1c-7.1,1.7-13.8,0.4-20.1-3.1c-1-0.6-1.5-1.3-1.5-2.5c0.1-2.2,0-4.5,0-7c0.5,0.2,0.8,0.4,1.1,0.6 c4.1,2.8,8.6,4.7,13.6,5.2c1.7,0.2,3.4-0.2,5-0.5c0.6-0.1,1.4-0.9,1.5-1.5c0-0.7-0.5-1.7-1-2c-1.4-0.8-2.9-1.3-4.4-1.8 c-2.9-0.9-5.8-1.6-8.6-2.6c-1.6-0.5-3.2-1.4-4.5-2.4c-4.2-3.2-3.9-9.2,0.5-12.1c3-2,6.4-2.3,9.8-2.3c5.2,0,10,1.5,14.6,3.8 c1,0.5,1.5,1,1.5,2.3C624.3,282.7,624.4,284.8,624.4,287.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M660.6,283.6c2.5,0,4.9,0,7.4,0c0.1,1.7,0.2,3.3,0.4,5.4c2.9-4.7,6.9-5.7,11.6-5.5c2.5,0.1,5,0.1,7.5,0 c1,0,1.4,0.3,1.8,1.3c1.5,4.3,3,8.6,4.5,12.9c0.2,0.6,0.5,1.2,0.8,2.2c1.8-5.2,3.5-9.9,5.1-14.6c0.4-1.3,1-1.8,2.3-1.7 c2.3,0.1,4.7,0,7.3,0c-1.1,2.6-2,4.9-3,7.2c-2,4.9-4.1,9.7-6.1,14.6c-0.4,1-0.9,1.3-1.9,1.3c-2.4-0.1-4.7-0.1-7.1,0 c-1.2,0-1.9-0.4-2.3-1.5c-2.7-6.5-5.4-13-8.2-19.5c-0.1-0.3-0.3-0.6-0.7-1c0,1.8,0,3.6,0,5.5c-1.9,0.3-3.6,0.4-5.3,0.8 c-4,0.9-5.6,2.7-5.9,6.9c-0.2,2.8,0,5.7,0,8.6c-2.8,0-5.3,0-8,0C660.6,298.9,660.6,291.3,660.6,283.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M835,303.2c0,4,0,7.9,0,11.9c-2.8,0-5.3,0-8,0c0-10.5,0-20.9,0-31.4c2.6,0,5.1,0,7.7,0 c0.1,1.1,0.2,2.1,0.3,3.4c0.8-0.8,1.5-1.5,2.2-2c6.5-5,16.3-1.3,17.6,6.8c0.4,2.3,0.4,4.8-0.1,7c-1.4,6.8-6.6,8.7-12.9,7.9 c-1.2-0.2-2.5-0.7-3.6-1.3C837.1,304.9,836.2,304.1,835,303.2z M846.8,295.1c0-3.5-2.1-5.5-5.7-5.6c-3.7,0-6.1,2-6.1,5.4 c0,3.5,2.2,5.6,5.9,5.6C844.6,300.5,846.8,298.5,846.8,295.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M768.9,306.5c0-10.5,0-20.9,0-31.4c9.3,0,18.5,0,27.9,0c0,2.2,0,4.3,0,6.7c-6.2,0-12.4,0-18.8,0 c0,1.8,0,3.2,0,4.9c6.3,0,12.5,0,18.8,0c0,2.1,0,4.1,0,6.4c-6.2,0-12.4,0-18.8,0c0,4.6,0,9,0,13.4 C774.8,306.5,771.9,306.5,768.9,306.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M717.6,296.6c0.5,2.6,2.2,3.9,4.8,4c4.1,0.2,7.9-0.8,11.7-2.3c0.8-0.3,1.5-0.6,2.4-1c0,1.7,0.1,3.2,0,4.6 c0,0.5-0.5,1.2-0.9,1.5c-5.6,3.4-11.6,4.6-18,2.8c-5.5-1.6-8.5-6.5-7.9-12.5c0.6-5.9,4.4-10,10.2-10.5c2.6-0.2,5.3-0.2,7.9,0.3 c6.2,1.4,9.5,6.4,8.7,13C730.2,296.6,723.9,296.6,717.6,296.6z M718.1,291.7c3.3,0,6.5,0,9.8,0 C725.5,288.4,720.1,288.4,718.1,291.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M766.1,283.5c-0.3,0.8-0.5,1.3-0.7,1.8c-4.2,9.4-8.4,18.8-12.5,28.2c-0.5,1.2-1.1,1.7-2.5,1.6 c-2.1-0.1-4.1,0-6.5,0c1-2.5,1.8-4.7,2.8-7c0.5-1.1,0.4-2-0.1-3.2c-3.1-6.5-6.2-13-9.2-19.5c-0.3-0.6-0.5-1.1-0.9-1.9 c2.8,0,5.3-0.1,7.8,0.1c0.5,0,1.2,0.7,1.4,1.2c1.8,4.4,3.6,8.8,5.3,13.1c0.2,0.4,0.3,0.7,0.7,1.4c0.7-1.8,1.3-3.3,1.9-4.8 c1.2-3.3,2.5-6.5,3.7-9.8c0.3-0.9,0.8-1.3,1.8-1.2C761.3,283.6,763.6,283.5,766.1,283.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M655.5,306.5c-2.3,0-4.5,0-6.9,0c0-1.4,0-2.8,0-4.1c-2.2,2.3-4.6,3.9-7.6,4.3c-5.6,0.8-9.7-1.6-10.1-7 c-0.4-5.3-0.1-10.7-0.1-16.2c2.3,0,4.8,0,7.6,0c0,3.2,0,6.4,0,9.6c0,0.7,0,1.4,0,2.1c0.1,2.5,1,4,3,4.5c2.3,0.5,4.6-0.3,5.6-2.4 c0.5-1,0.8-2.2,0.8-3.4c0.1-3.4,0-6.9,0-10.4c2.6,0,5.1,0,7.8,0C655.5,291.2,655.5,298.8,655.5,306.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M801,275.1c2.7,0,5.2,0,7.9,0c0,10.5,0,20.9,0,31.4c-2.6,0-5.2,0-7.9,0C801,296,801,285.7,801,275.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M822.1,283.7c0,7.6,0,15.2,0,22.8c-2.7,0-5.2,0-7.9,0c0-7.6,0-15.1,0-22.8 C816.8,283.7,819.3,283.7,822.1,283.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M814.2,274c2.6,0,5.1,0,7.8,0c0,2,0,4,0,6.1c-2.5,0-5.1,0-7.8,0C814.2,278,814.2,276.1,814.2,274z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "28.5,15.5 47.3,12.6 47.3,23.2 37.1,24.9 37.1,34.8 28.5,36.2 23.8,35.5 24.1,14.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M24.9,35.7c-3.2-0.5-23.1-3.8-23.3-3.8V23c0.6,0.2,12.7,2.1,17.2,2.8c1.4,0.2,1.9-0.4,1.9-1.1 s-0.1-1.5-1.4-1.7c-1.5-0.3-7.9-1.1-10.4-1.6c-4.2-1-7.6-4.9-6.7-11.1C3.5,1,11.2,1,14.8,1.5c2.1,0.3,13.7,2.3,13.7,2.3v8.7 c0,0-13.1-2.1-14.7-2.3s-2.4,0.2-2.4,1.1c0,1,0.4,1.4,2,1.7c3.7,0.6,15.1,2.5,15.1,2.5s4.4,1.4,4.4,9.8 C32.9,32.6,28.2,36.1,24.9,35.7z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st25",
    points: "28.5,3.8 47.3,1.2 47.3,9.5 28.5,12.5  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyFlipLogoIcon);
export default __webpack_public_path__ + "static/media/surveyFlip-logo-icon.2e3e6b7b4cae49d539bc2ee4ac63118d.svg";
export { ForwardRef as ReactComponent };